
import { relatedFormatted } from '~/utils'
export default {
  name: 'RelatedAccessories',
  props: {
    relatedAccessories: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    formattedAccessories() {
      return relatedFormatted(this.relatedAccessories)
    },
  },
}
